/**
 * @generated SignedSource<<7259c69ca2965b0ae1a549f5d699cccb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProjectPhoto_tradePhoto$data = {
  readonly path: string | null;
  readonly url: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"ProjectPhotoLikeWrapper_tradePhoto">;
  readonly " $fragmentType": "ProjectPhoto_tradePhoto";
};
export type ProjectPhoto_tradePhoto$key = {
  readonly " $data"?: ProjectPhoto_tradePhoto$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProjectPhoto_tradePhoto">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProjectPhoto_tradePhoto",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "path",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "url",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ProjectPhotoLikeWrapper_tradePhoto"
    }
  ],
  "type": "TradePhoto",
  "abstractKey": null
};

(node as any).hash = "8073d5af363e4ffbd13327951dc89c17";

export default node;
